import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import { css } from '@emotion/react';

import { LOCAL_CONTENT_MAX_WIDTH, LOCAL_SPACING } from 'styles/constants';
import { mobileOnly, desktopOnly } from 'styles/mixins/displayMobileDesktop';
import getContrastingColor from 'utils/getContrastingColor';

export const MainBox = styled.div<{ backgroundColor: string }>`
  background: ${({ backgroundColor }) => backgroundColor};
  --text-color: ${({ backgroundColor }) =>
    backgroundColor && getContrastingColor(backgroundColor)};
  h2,
  p,
  small {
    color: var(--text-color);
  }
`;

export const InnerBox = styled.div`
  max-width: ${LOCAL_CONTENT_MAX_WIDTH};
  margin: auto;
  padding: ${SPACER.x4large} 0 ${SPACER.x2large};
  position: relative;

  ${MEDIA_QUERIES.mdUp} {
    padding: 80px ${SPACER.x5large} ${LOCAL_SPACING.desktopMainPadding}
      ${SPACER.medium};
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  ${MEDIA_QUERIES.xlUp} {
    padding: 80px ${LOCAL_SPACING.desktopMainPadding}
      ${LOCAL_SPACING.desktopMainPadding};
  }
`;

export const TextBox = styled.div`
  padding: 0 ${SPACER.large};

  ${MEDIA_QUERIES.mdUp} {
    padding: 0;
    max-width: 368px;
  }
`;

export const bodyStyles = css`
  padding-top: ${SPACER.base};
`;

export const MobileIngredientsBox = styled.div`
  ${mobileOnly('flex')};
  margin-top: ${SPACER.xlarge};
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
  min-height: 185px;
  ${MEDIA_QUERIES.mdUp} {
    min-height: auto;
  }

  :before,
  :after {
    content: '\xa0';
    padding: 0 12px;
  }
`;

export const DesktopIngredientsBox = styled.div`
  ${desktopOnly('flex')};
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  align-self: center;
  max-width: 688px;
`;

export const DesktopBar = styled.div`
  ${desktopOnly()};
  margin-top: ${SPACER.large};
  border-bottom: 2px solid var(--text-color);
  width: 35px;
`;

export const disclaimerStyles = css`
  opacity: 0.6;
  margin-top: ${SPACER.xlarge};
  padding-left: ${SPACER.large};

  ${MEDIA_QUERIES.mdUp} {
    margin-top: ${SPACER.large};
    padding-left: 0;
    max-width: 368px;
  }
`;
